import { render, staticRenderFns } from "./SocialButtons.vue?vue&type=template&id=6828b384"
import script from "./SocialButtons.vue?vue&type=script&lang=js"
export * from "./SocialButtons.vue?vue&type=script&lang=js"
import style0 from "./SocialButtons.vue?vue&type=style&index=0&id=6828b384&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports